
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ebooks",
      function () {
        return require("private-next-pages/ebooks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ebooks"])
      });
    }
  